import { authStoreUserTournamentId } from 'modules/auth/store/selectors';
import { ListPlayersArgs, useListPlayersQuery } from 'modules/players/store/players-api';
import { useSelector } from 'react-redux';
import { useOffsetPagination } from 'shared/hooks/use-offset-pagination';

const filtersConfig = {
  nameFilter: { key: 'nameFilter', defaultValue: '' as string },
};

export function usePlayersList() {
  const tournamentId = useSelector(authStoreUserTournamentId);

  return useOffsetPagination<any, ListPlayersArgs, typeof filtersConfig>({
    useQueryHook: useListPlayersQuery,
    baseArgs: { tournamentId: Number(tournamentId) },
    mapFiltersToArgs: (f) => ({
      nameFilter: f.nameFilter || undefined,
    }),
    filtersConfig,
    perPageStorageKey: 'playersPerPage',
    defaultPerPage: 10,
    queryOptions: () => ({ skip: !tournamentId }),
  });
}
